/* ═══════════════ SIZE CALCULATOR — Config-Driven Drawer ═══════════════ */
(function(){
  'use strict';

  /* ═══════════════════════════════════════════
     ★ CONFIGURATIONS — Edit images/text here
     ═══════════════════════════════════════════
     To add more: copy one config block, change the index,
     upload your assets, and update the filenames below.
     Then use: onclick="openSizeCalculator(4)"
  */
  var scConfigs = [

    /* ── Config 0: Bra (Default) ── */
    /* ── Config 0: Bra (Default) ── */
    {
      chartInch: 'size-guide-inch.jpg',
      chartCm:   'size-guide-cm.jpg',
      introVideo: 'underbust.mp4',
      introTitle: 'Unlock your perfect fit in minutes',
      introDesc:  'Watch and learn how to measure your bra size the right way.',
      tips: [
        'Measure yourself in a non-padded bra using a tape.',
        'Ensure the tape is snug and level all around.'
      ],
      ubVideo: 'underbust.mp4',
      ubTitle: 'How to measure your underbust',
      ubDesc:  'Place the tape snugly under your bust, keeping it level and straight around your body.',
      obVideo: 'overbust.mp4',
      obTitle: 'How to measure your overbust',
      obDesc:  'Wrap the tape around the fullest part of your bust, keeping it level and comfortable.'
    },

    /* ── Config 1: Copy & customize ── */
    {
      chartInch: 'Size Guide.png',      /* ← change to your image */
      chartCm:   'Size Guide CM.png',    /* ← change to your CM image */
      introVideo: 'Underbust.mp4',       /* ← change intro video */
      introTitle: 'Unlock your perfect fit in minutes',  /* ← change title */
      introDesc:  'Watch and learn how to measure your bra size the right way.',  /* ← change desc */
      tips: [
        'Measure yourself in a non-padded bra using a tape.',
        'Ensure the tape is snug and level all around.'
      ],
      ubVideo: 'Underbust.mp4',          /* ← change underbust video */
      ubTitle: 'How to measure your underbust',
      ubDesc:  'Place the tape snugly under your bust, keeping it level and straight around your body.',
      obVideo: 'Overbust.mp4',           /* ← change overbust video */
      obTitle: 'How to measure your overbust',
      obDesc:  'Wrap the tape around the fullest part of your bust, keeping it level and comfortable.'
    },

    /* ── Config 2: Copy & customize ── */
    {
      chartInch: 'Size Guide.png',
      chartCm:   'Size Guide CM.png',
      introVideo: 'Underbust.mp4',
      introTitle: 'Unlock your perfect fit in minutes',
      introDesc:  'Watch and learn how to measure your bra size the right way.',
      tips: [
        'Measure yourself in a non-padded bra using a tape.',
        'Ensure the tape is snug and level all around.'
      ],
      ubVideo: 'Underbust.mp4',
      ubTitle: 'How to measure your underbust',
      ubDesc:  'Place the tape snugly under your bust, keeping it level and straight around your body.',
      obVideo: 'Overbust.mp4',
      obTitle: 'How to measure your overbust',
      obDesc:  'Wrap the tape around the fullest part of your bust, keeping it level and comfortable.'
    },

    /* ── Config 3: Copy & customize ── */
    {
      chartInch: 'Size Guide.png',
      chartCm:   'Size Guide CM.png',
      introVideo: 'Underbust.mp4',
      introTitle: 'Unlock your perfect fit in minutes',
      introDesc:  'Watch and learn how to measure your bra size the right way.',
      tips: [
        'Measure yourself in a non-padded bra using a tape.',
        'Ensure the tape is snug and level all around.'
      ],
      ubVideo: 'Underbust.mp4',
      ubTitle: 'How to measure your underbust',
      ubDesc:  'Place the tape snugly under your bust, keeping it level and straight around your body.',
      obVideo: 'Overbust.mp4',
      obTitle: 'How to measure your overbust',
      obDesc:  'Wrap the tape around the fullest part of your bust, keeping it level and comfortable.'
    },

    /* ── Config 4: Copy & customize ── */
    {
      chartInch: 'Size Guide.png',
      chartCm:   'Size Guide CM.png',
      introVideo: 'Underbust.mp4',
      introTitle: 'Unlock your perfect fit in minutes',
      introDesc:  'Watch and learn how to measure your bra size the right way.',
      tips: [
        'Measure yourself in a non-padded bra using a tape.',
        'Ensure the tape is snug and level all around.'
      ],
      ubVideo: 'Underbust.mp4',
      ubTitle: 'How to measure your underbust',
      ubDesc:  'Place the tape snugly under your bust, keeping it level and straight around your body.',
      obVideo: 'Overbust.mp4',
      obTitle: 'How to measure your overbust',
      obDesc:  'Wrap the tape around the fullest part of your bust, keeping it level and comfortable.'
    }
  ];
  /* ═══════════════════════════════════════════ */

  /* ── Size data ── */
  var sizeChart=[
    {band:[24.5,26.5],bust:[30.00,31.00],size:"30A",fit:"XS"},
    {band:[24.5,26.5],bust:[31.00,32.00],size:"30B",fit:"XS"},
    {band:[24.5,26.5],bust:[32.00,33.00],size:"30C",fit:"XS"},
    {band:[24.5,26.5],bust:[32.50,34.00],size:"30D",fit:"S"},
    {band:[26.5,28.5],bust:[32.00,33.00],size:"32A",fit:"S"},
    {band:[26.5,28.5],bust:[33.00,34.00],size:"32B",fit:"S"},
    {band:[26.5,28.5],bust:[34.00,34.50],size:"32C",fit:"S"},
    {band:[26.5,28.5],bust:[34.50,35.50],size:"32D",fit:"M"},
    {band:[28.5,30.5],bust:[34.50,35.00],size:"34A",fit:"M"},
    {band:[28.5,30.5],bust:[35.00,36.00],size:"34B",fit:"M"},
    {band:[28.5,30.5],bust:[36.00,36.50],size:"34C",fit:"M"},
    {band:[28.5,30.5],bust:[36.50,37.50],size:"34D",fit:"L"},
    {band:[28.5,30.5],bust:[37.50,38.00],size:"34DD",fit:"XL"},
    {band:[30.5,32.5],bust:[36.00,37.00],size:"36A",fit:"L"},
    {band:[30.5,32.5],bust:[37.00,38.00],size:"36B",fit:"L"},
    {band:[30.5,32.5],bust:[37.50,38.50],size:"36C",fit:"L"},
    {band:[30.5,32.5],bust:[38.50,39.50],size:"36D",fit:"XL"},
    {band:[30.5,32.5],bust:[39.50,40.00],size:"36DD",fit:"2XL"},
    {band:[32.5,34.5],bust:[38.00,39.00],size:"38A",fit:"XL"},
    {band:[32.5,34.5],bust:[39.00,40.00],size:"38B",fit:"XL"},
    {band:[32.5,34.5],bust:[39.50,40.50],size:"38C",fit:"2XL"},
    {band:[32.5,34.5],bust:[40.50,41.50],size:"38D",fit:"2XL"},
    {band:[32.5,34.5],bust:[41.50,42.00],size:"38DD",fit:"3XL"},
    {band:[34.5,36.5],bust:[41.00,41.50],size:"40B",fit:"2XL"},
    {band:[34.5,36.5],bust:[41.50,42.50],size:"40C",fit:"3XL"},
    {band:[34.5,36.5],bust:[42.50,43.50],size:"40D",fit:"3XL"},
    {band:[34.5,36.5],bust:[43.50,44.00],size:"40DD",fit:"4XL"},
    {band:[36.5,38.5],bust:[43.00,43.50],size:"42B",fit:"4XL"},
    {band:[36.5,38.5],bust:[43.50,44.00],size:"42C",fit:"4XL"},
    {band:[36.5,38.5],bust:[44.50,45.50],size:"42D",fit:""}
  ];
  var bandRanges=[{min:24.5,max:26.5},{min:26.5,max:28.5},{min:28.5,max:30.5},{min:30.5,max:32.5},{min:32.5,max:34.5},{min:34.5,max:36.5},{min:36.5,max:38.5}];

  /* ── State ── */
  var S = {
    under:{value:25.5,unit:'in',min:24.5,max:38.5},
    over:{value:30.5,unit:'in',min:30.0,max:45.5}
  };
  var STEP = 0.5;
  var cm2in = function(v){return v/2.54;};
  var in2cm = function(v){return v*2.54;};
  var screens = ['scScreenChart','scScreenFitIntro','scScreenUnderbust','scScreenOverbust','scScreenSummary'];
  var scLastFit = '';
  var scCurrentConfig = 0;

  /* ── Helpers ── */
  function fmt(n){return(Math.round(n*100)/100).toString().replace(/\.00$/,'').replace(/(\.\d)0$/,'$1');}
  function $(id){return document.getElementById(id);}
//   function assetUrl(file){return (window.SC_ASSETS||'')+file;}

  /* ── Load config into drawer ── */
   function loadConfig(idx){
    var c = scConfigs[idx];
    if(!c) return;
    scCurrentConfig = idx;

    /* Reset state */
    S.under.value = 25.5; S.under.unit = 'in';
    S.over.value = 30.5;  S.over.unit = 'in';
    scLastFit = '';
    $('scUbInput').value = '25.5';
    $('scObInput').value = '30.5';
    $('scUbValMsg').textContent = '';
    $('scObValMsg').textContent = '';
    resetPills('under');
    resetPills('over');
    $('scUnitSwitch').checked = false;
    scToggleChartImage();

    /* Reset videos — reload to play from start */
    var vids = ['scIntroVideoEl','scUbVideoEl','scObVideoEl'];
    vids.forEach(function(id){
      var v = $(id);
      if(v) { v.currentTime = 0; v.load(); v.play().catch(function(){}); }
    });
  }

  function resetPills(which){
    var cm = $(which==='under'?'scUbPillCm':'scObPillCm');
    var inn = $(which==='under'?'scUbPillIn':'scObPillIn');
    cm.classList.remove('active');
    inn.classList.add('active');
    var wrap = $(which==='under'?'scUbInput':'scObInput');
    var w = wrap.closest('.sc-input-wrap');
    w.querySelector('.sc-cm-label').style.display='none';
    w.querySelector('.sc-in-label').style.display='inline';
  }

//   function setVideoSrc(videoEl, src){
//     if(!videoEl) return;
//     var source = videoEl.querySelector('source');
//     if(source){
//       source.src = assetUrl(src);
//       videoEl.load();
//       videoEl.play().catch(function(){});
//     }
//   }

  /* ═══════════════ OPEN / CLOSE ═══════════════ */
  window.openSizeCalculator = function(idx){
    idx = idx || 0;
    loadConfig(idx);
    scGoTo('scScreenChart');
    $('scBackdrop').classList.add('open');
    $('scDrawer').classList.add('open');
    document.body.style.overflow = 'hidden';
    buildTape('under');
    buildTape('over');
  };

  window.closeSizeCalculator = function(){
    $('scBackdrop').classList.remove('open');
    $('scDrawer').classList.remove('open');
    document.body.style.overflow = '';
  };

  document.addEventListener('DOMContentLoaded',function(){
    var bd = $('scBackdrop');
    if(bd) bd.addEventListener('click', closeSizeCalculator);
  });

  document.addEventListener('keydown',function(e){
    if(e.key==='Escape' && $('scDrawer') && $('scDrawer').classList.contains('open')){
      closeSizeCalculator();
    }
  });

  /* ═══════════════ CHART TOGGLE ═══════════════ */
  window.scToggleChartImage = function(){
    var isInch = !$('scUnitSwitch').checked;
    $('scChartImgInch').classList.toggle('sc-hidden', !isInch);
    $('scChartImgCm').classList.toggle('sc-hidden', isInch);
  };

  /* ═══════════════ NAVIGATION ═══════════════ */
  window.scGoTo =   function reloadVideo(vid){
    var v=$(vid);
    if(v){v.load();v.play().catch(function(){});}
  }

  window.scGoTo = function(id){
    screens.forEach(function(s){
      var el=$(s); if(el) el.classList.toggle('sc-hidden',s!==id);
    });
    $('scEntryCta').classList.toggle('sc-hidden',id!=='scScreenChart');
    $('scFitIntroBtns').classList.toggle('sc-hidden',id!=='scScreenFitIntro');
    if(id==='scScreenFitIntro') reloadVideo('scIntroVideoEl');
    if(id==='scScreenUnderbust') reloadVideo('scUbVideoEl');
    if(id==='scScreenOverbust') reloadVideo('scObVideoEl');
    requestAnimationFrame(function(){requestAnimationFrame(function(){
      if(id==='scScreenUnderbust') scrollTapeTo('under');
      if(id==='scScreenOverbust') scrollTapeTo('over');
    });});
  };

  /* ═══════════════ INPUT ═══════════════ */
  window.scRestrictInput = function(e){
    if(!/^\d$/.test(e.key)&&e.key!=='.') e.preventDefault();
  };

  window.scValidateInput = function(which){
    var input=$(which==='under'?'scUbInput':'scObInput');
    var msg=$(which==='under'?'scUbValMsg':'scObValMsg');
    var s=S[which];
    var raw=input.value.replace(/[^0-9.]/g,'');
    var val=parseFloat(raw);
    if(raw===''||isNaN(val)){msg.textContent='';return;}
    if(val<s.min||val>s.max){msg.textContent='Enter '+fmt(s.min)+' – '+fmt(s.max);return;}
    msg.textContent='';
    s.value=Math.round(val/STEP)*STEP;
    input.value=fmt(s.value);
    buildTape(which);
    scrollTapeTo(which);
  };

  /* ═══════════════ TAPE ═══════════════ */
  function buildTape(which){
    var strip=$(which==='under'?'scTapeUnder':'scTapeOver');
    var s=S[which]; strip.innerHTML='';
    for(var i=s.min;i<=s.max+0.001;i+=STEP){
      var div=document.createElement('div');
      var isMajor=Math.abs(i%1)<0.01;
      var isCur=Math.abs(i-s.value)<0.01;
      div.className='sc-tape-tick '+(isMajor?'major':'minor')+(isCur?' active':'');
      var label=s.unit==='in'?fmt(i):fmt(in2cm(i));
      if(isMajor||isCur){
        var span=document.createElement('span');
        span.className='sc-tape-tick-label';
        span.textContent=label;
        div.appendChild(span);
      }
      strip.appendChild(div);
    }
    scrollTapeTo(which);
  }

  function scrollTapeTo(which){
    var strip=$(which==='under'?'scTapeUnder':'scTapeOver');
    var track=strip.parentElement;
    var s=S[which];
    var idx=Math.round((s.value-s.min)/STEP);
    var tickW=strip.children[0]?strip.children[0].offsetWidth:32;
    track.scrollLeft=idx*tickW+tickW/2-track.clientWidth/2;
  }

  function updateDisplay(which){
    var s=S[which];
    var shown=s.unit==='in'?fmt(s.value):fmt(in2cm(s.value));
    var input=$(which==='under'?'scUbInput':'scObInput');
    input.value=shown;
    var wrap=input.closest('.sc-input-wrap');
    var cmEl=wrap.querySelector('.sc-cm-label');
    var inEl=wrap.querySelector('.sc-in-label');
    if(cmEl) cmEl.style.display=s.unit==='cm'?'inline':'none';
    if(inEl) inEl.style.display=s.unit==='in'?'inline':'none';
    var msg=wrap.querySelector('.sc-val-msg');
    if(msg) msg.textContent='';
    buildTape(which);
  }

  window.scStep = function(which,dir){
    var s=S[which];
    s.value=Math.min(s.max,Math.max(s.min,Math.round((s.value+dir*STEP)*10)/10));
    updateDisplay(which);
    scrollTapeTo(which);
  };

  window.scSetUnit = function(which,unit){
    S[which].unit=unit;
    var cmPill=$(which==='under'?'scUbPillCm':'scObPillCm');
    var inPill=$(which==='under'?'scUbPillIn':'scObPillIn');
    cmPill.classList.toggle('active',unit==='cm');
    inPill.classList.toggle('active',unit==='in');
    updateDisplay(which);
  };

  function initTapeScroll(which){
    var strip=$(which==='under'?'scTapeUnder':'scTapeOver');
    var track=strip.parentElement;
    var raf;
    track.addEventListener('scroll',function(){
      cancelAnimationFrame(raf);
      raf=requestAnimationFrame(function(){
        var center=track.scrollLeft+track.clientWidth/2;
        var closest=null,minD=Infinity;
        Array.prototype.forEach.call(strip.children,function(t){
          var tc=t.offsetLeft+t.offsetWidth/2;
          var d=Math.abs(center-tc);
          if(d<minD){minD=d;closest=t;}
        });
        if(closest&&minD<20){
          var idx=Array.prototype.indexOf.call(strip.children,closest);
          var s=S[which];
          var newVal=Math.round((s.min+idx*STEP)*10)/10;
          if(newVal!==s.value){
            s.value=newVal;
            var shown=s.unit==='in'?fmt(s.value):fmt(in2cm(s.value));
            $(which==='under'?'scUbInput':'scObInput').value=shown;
            Array.prototype.forEach.call(strip.querySelectorAll('.sc-tape-tick'),function(t){t.classList.remove('active');});
            closest.classList.add('active');
          }
        }
      });
    },{passive:true});
  }

  /* ═══════════════ SUMMARY ═══════════════ */
  window.scShowSummary = function(){
    var u=S.under.value, o=S.over.value;
    $('scSummaryUnder').textContent=(S.under.unit==='in'?fmt(u)+' in':fmt(in2cm(u))+' cms');
    $('scSummaryOver').textContent=(S.over.unit==='in'?fmt(o)+' in':fmt(in2cm(o))+' cms');
    var band=bandRanges.find(function(b){return u>=b.min&&u<=b.max;});
    var m=null;
    if(band) m=sizeChart.find(function(r){return r.band[0]===band.min&&r.band[1]===band.max&&o>=r.bust[0]&&o<=r.bust[1];})||null;
    var na=$('scNotAvail');
    if(m){
      $('scSummaryResult').textContent=m.size+(m.fit?' \u00B7 '+m.fit:'');
      scLastFit = m.fit;
      na.classList.add('sc-hidden');
    } else {
      $('scSummaryResult').textContent='--';
      scLastFit = '';
      na.classList.remove('sc-hidden');
    }
    scGoTo('scScreenSummary');
  };

  /* ═══════════════ SELECT FIT — Auto-selects PDP variant ═══════════════ */
  window.scSelectFit = function(){
    if(!scLastFit) { closeSizeCalculator(); return; }
    var targetSize = scLastFit.trim().toUpperCase();
    var inputs = document.querySelectorAll('input.product-option__input:not([id*="recommendations"])');
    var selected = false;
    inputs.forEach(function(input){
      var value = input.value.trim().toUpperCase();
      if(value === targetSize){
        input.click();
        input.dispatchEvent(new Event('change',{bubbles:true}));
        selected = true;
      }
    });
    if(!selected){
      console.log('[Size Calculator] No matching variant found for:', targetSize);
    }
    closeSizeCalculator();
  };

  /* ═══════════════ INIT ═══════════════ */
  document.addEventListener('DOMContentLoaded',function(){
    buildTape('under');
    buildTape('over');
    initTapeScroll('under');
    initTapeScroll('over');
  });

})();